import Select, { OnChangeValue } from 'react-select';
import { Option } from '../models/table-models';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { Form } from 'react-bootstrap';

export interface FormSelectProps {
    label?: string;
    setValue: (string: string[]) => void;
    options: Option[];
    defaultValue?: Option[];
    value?: Option[];
    errorTextClassName?: string;
}

export const stringsToOptions = (values: string[] | undefined): Option[] => {
    return values ? values?.map(stringToOption) : [];
};
export const stringToOption = (value: string | undefined): Option => {
    return { value: value ?? '', name: value ?? '' };
};

export const FormMultiSelect = ({ label, setValue, errorTextClassName, ...props }: FormSelectProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'multiselect' });
    const onChange = (value: OnChangeValue<Option, true>) => {
        const strings = value.map(({ value }) => value);
        setValue(strings);
    };
    return (
        <div className='p-0 d-flex flex-column w-100'>
            {label ? <Form.Label>{label}</Form.Label> : null}
            <Select
                id='roles'
                onChange={onChange}
                isMulti
                isClearable
                getOptionLabel={(option) => t(option.name)}
                getOptionValue={(option) => option.value}
                backspaceRemovesValue
                {...props}
            />
        </div>
    );
};
